// feature-module/sales/GSTQRCode.jsx
import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import { toast } from "react-toastify";
import { barcodeAPI } from "../../core/action/api";

const GSTQRCode = ({ saleId, invoiceNo, onClose }) => {
    const [qrData, setQrData] = useState(null);
    const [loading, setLoading] = useState(false);

    const generateQR = async () => {
        setLoading(true);
        try {
            const result = await barcodeAPI.generateGSTQR(saleId);
            
            if (result.success) {
                setQrData(result.data);
                toast.success('GST QR Code generated successfully');
            } else {
                toast.error(result.message || 'Failed to generate QR code');
            }
        } catch (error) {
            console.error('Error generating GST QR:', error);
            toast.error('Failed to generate QR code');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (saleId) {
            generateQR();
        }
    }, [saleId]);

    const handlePrint = () => {
        if (qrData?.qr_image) {
            const printWindow = window.open(qrData.qr_image, '_blank');
            printWindow?.print();
        }
    };

    return (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">GST QR Code - {invoiceNo}</h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body text-center">
                        {loading ? (
                            <div className="py-4">
                                <div className="spinner-border text-primary mb-3"></div>
                                <p>Generating QR Code...</p>
                            </div>
                        ) : qrData ? (
                            <>
                                <div className="mb-4">
                                    <img 
                                        src={qrData.qr_image} 
                                        alt="GST QR Code"
                                        style={{ maxWidth: '250px', maxHeight: '250px' }}
                                    />
                                </div>
                                <div className="text-start">
                                    <p><strong>Invoice No:</strong> {qrData.invoice_no}</p>
                                    <p><strong>QR Data:</strong></p>
                                    <pre className="bg-light p-2 small" style={{ fontSize: '10px', wordBreak: 'break-all' }}>
                                        {qrData.qr_string}
                                    </pre>
                                    <p><strong>GST Details:</strong></p>
                                    <pre className="bg-light p-2 small">
                                        {JSON.stringify(qrData.gst_details, null, 2)}
                                    </pre>
                                </div>
                            </>
                        ) : (
                            <p>Failed to generate QR code</p>
                        )}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>
                            Close
                        </button>
                        {qrData && (
                            <button type="button" className="btn btn-primary" onClick={handlePrint}>
                                Print QR
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

GSTQRCode.propTypes = {
    saleId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    invoiceNo: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired
};

export default GSTQRCode;